module.exports = "/static/assets/9bc717fc42785b5bd4c5d5846ab18118.png";